export class ServiceList  {
    caisService!: string;
    catService!: string;
    createCatRoeService!: string;
    regReporting!: string;
    regmmsymbolService!: string;
}